// extracted by mini-css-extract-plugin
export default {"low":"WmTvkur4FdqgoUsCqJTD"};